module.exports = __webpack_public_path__ + "img/entrance.cedd0fbe.png";